import axios from "../lib/axios-config";
const getProducts = ()=>axios.get("/product");
const getProduct = (productId)=>axios.get("/product/".concat(productId));
const createNewProduct = (payload)=>axios.post("/product/create", payload);
const copyProduct = (productId)=>axios.post("/product/".concat(productId, "/copy"));
const deleteProduct = (productId)=>axios.delete("/product/".concat(productId));
const editProduct = (productId, payload)=>axios.put("/product/".concat(productId), payload);
export const ProductApi = {
    getProducts,
    createNewProduct,
    copyProduct,
    deleteProduct,
    getProduct,
    editProduct
};
